module.exports = __webpack_public_path__ + "static/media/line-motion.27fa0bd7.lottie";